import Spinner from 'components/Spinner';
import PropTypes from 'prop-types';
import React from 'react';
import { Translate } from 'react-redux-i18n';
import { Container, Fixed, Flex } from 'rebass';
import { PvBox, PvButton, WizardActionsPanel } from 'styles/CustomComponents';
import PreviousLink from './PreviousLink';

const WizardActions = ({additionalComponent, nextFn, nextText, nextDisabled, previousFn, previousText, loading}) => (
  <Fixed left={0} right={0} bottom={0}>
    <WizardActionsPanel py={4} px={[1, 2, 2]} textAlign='center'>
      <Container>
        <Flex justifyContent={!additionalComponent && !previousFn ? 'center' : 'space-between'} alignItems='center'
              flexWrap='wrap'>
          {!!previousFn && typeof previousFn === 'function' &&
          <PreviousLink previousFn={previousFn} previousText={previousText} />
          }
          {!!nextFn && typeof nextFn === 'function' && !loading &&
          <PvButton disabled={nextDisabled} onClick={() => nextFn()}>
            <Translate value={nextText || 'action.next'} />
          </PvButton>
          }
          {!!loading &&
          <PvBox height={48}>
            <Spinner type='inline' />
          </PvBox>
          }
          {!!additionalComponent &&
          additionalComponent
          }
        </Flex>
      </Container>
    </WizardActionsPanel>
  </Fixed>
);

WizardActions.propTypes = {
  additionalComponent: PropTypes.node,
  nextFn: PropTypes.func,
  nextText: PropTypes.string,
  nextDisabled: PropTypes.bool,
  loading: PropTypes.bool,
  previousFn: PropTypes.func,
  previousText: PropTypes.string,
};

export default WizardActions;


// WEBPACK FOOTER //
// ./src/components/WizardActions.jsx